export const fioUrl = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio";
export const addressUrl = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
export const token = 'b50a85ca267842676823047a9b5dc984e65ca557';